import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import styles from './fast-selling-badge.scss'

const FastSellingBadge = ({ badgeText }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <div className="fast-selling-badge">
      <div className="fast-selling-badge__wrapper">
        <span className={clsx(Typo.body2)}>{badgeText}</span>
      </div>
    </div>
  </React.Fragment>
)

FastSellingBadge.defaultProps = {
  badgeText: '',
}

FastSellingBadge.propTypes = {
  badgeText: PropTypes.string,
}

export default withI18next()(FastSellingBadge)
